export const ELK_MONITORING_CONFIG = {
  host: "https://31873324ae8046a0aaefa862f6e7a910.eu-central-1.aws.cloud.es.io:9243/s/",
  dev: {
    space: "eem_dev_space",
    items: [
      {
        name: "dashboards",
        prefix: "/app/dashboards#/view/",
        title: "Dashboards",
        description:
          "These are the APIGW monitoring dashboards in ELK. Configured these dashboards based on metricbeat,filebeat and latency. ",
        items: [
          {
            name: "EEM AWS API Gateway Dashboard - Filebeat",
            id: "b8ea8de6-b43b-5f91-8e9e-f7dd9c5a3b7a",
            description:
              "The EEM API Gateway Dashboard built on the ELK Stack using Filebeat provides real-time monitoring and insights into both REST and WebSocket API traffic of EEM.Filebeat is responsible for collecting logs from AWS API Gateway (via CloudWatch or S3), parsing them (directly or via Logstash), and forwarding them to Elasticsearch, where they are indexed and visualized in Kibana. It capture the Rest API Errors 4XX,Rest API Errors 5XX,Websocket API 4XX errors,Websocket API 5XX errors,Websocket API - Latency between CloudFront viewer request and response,RestApi - Latency between APigateway and curity authorizer,APIGateway Throttling Error - RestAPIs and APIGateway Throttling Error - WebsocketAPI",
          },
          {
            name: "EEM AWS API Gateway Dashboard - Metricbeats",
            id: "293a5d82-0543-543b-a1c0-6bdc4c6ca64d",
            description:
              "This dashboard provides a comprehensive visualization of API usage patterns for both WebSocket and REST APIs managed under the EEM, using data collected via Metricbeat and displayed in Kibana on the ELK stack.This dashboard visualize the Top 10 REST API Routes(commonly invoked REST API endpoints and their relative usage) ,Top 10 WebSocket API Routes(Highlights the most frequently accessed WebSocket API routes, showing proportional usage),Bottom 10 WebSocket Routes(east-used WebSocket routes),Bottom 10 REST API Routes(least-called REST API routes),Rest/Websocket API calls per day, Rest/Websocket API trends per hour,Websocket API - Integration Latency(APIGW +Backend) by routes, Rest API- Integration Latency (API GW + Backend ) by routes, Websocket API - Round trip latency(Curity+APIGW+Backend) by routes, Rest API - Round trip latency(Curity +APIGW+Backend) by routes,Rest API 4XX and 5XX metrics,Websocket API error metrics,API Calls - All Websocket Routes calls and API Calls - All Rest methods calls",
          },
          {
            name: "EEM AWS API Gateway Dashboard - Latency",
            id: "15acffe5-4586-50eb-bb6f-ccf00cb9a260",
            description:
              "The EEM API Gateway Latency Dashboard is a Kibana visualization built on top of Filebeat-ingested logs that monitors API integration latency for both REST and WebSocket APIs in real time. It visualize the Rest API- Integration Latency (API GW + Backend ) by routes, Websocket API -Integration Latency(APIGW +Backend) by routes, Rest API - Round trip latency(Curity +APIGW+Backend) by routes and Websocket API - Round trip latency(Curity +APIGW+Backend) by routes",
          },
        ],
      },
      {
        name: "cloudfrontAlerts",
        prefix: "/app/observability/alerts/rules/",
        title: "Cloudfront Alerts",
        description:
          "This is the generic alert created for the cloudfront distribution based on metricbeat. it capture the 5xx error in the logs and notify EEM APIGW team by MS Team notification",
        items: [
          {
            name: "Generic-APIGW-CF- 5xxErrorRate -alert",
            id: "6192a770-3257-11f0-b6ad-0f24c92cb25d",
            description:
              "A CloudFront 5XXErrorRate alert monitors the rate of 5xx server errors (such as 500, 502, 503, 504) that occur between CloudFront and API.A CloudFront 5XXErrorRate alert is triggered when the percentage of server-side errors (HTTP 5xx status codes) returned by CloudFront to clients exceeds a defined threshold over a specified period.",
          },
        ],
      },
      {
        name: "restAlerts",
        prefix: "/app/observability/alerts/rules/",
        title: "REST Alerts",
        description:
          "These are the generic alert created for the REST API in EEM APIGateway Console based on metricbeat and filebeat. it capture the 4xx,5xx,latency,backend network,vpc link,invalid token,throttle request count and execution error in logs and notify EEM APIGW team by MS Team notification",
        items: [
          {
            name: "Generic-APIGW-Rest-BackendNetworkError-Alert",
            id: "125b94b0-240a-11f0-a9f8-3ba7ee780118",
            description:
              "A Backend Network Error alert in ELK for REST APIs is triggered when log data indicates that the API request failed to connect, timed out, or received no response from the backend service due to network connectivity problems, DNS resolution failures, or backend unavailability.",
          },
          {
            name: "Generic-APIGW-Rest-ExecutionError-alert",
            id: "a066cd10-240a-11f0-9c33-7f85a1328d7a",
            description:
              "An ExecutionError alert is triggered from ELK when REST API logs show that a request was routed to the backend, but the execution of that request failed due to internal application errors, timeouts, or exceptions, typically resulting in 5xx HTTP status codes (e.g., 500, 502, 503).",
          },
          {
            name: "Generic-APIGW-Rest-InvalidToken-alert",
            id: "a4f0a580-240b-11f0-9d30-fd44abfeb00b",
            description:
              "An InvalidToken alert in the context of a REST API monitored through ELK indicates that a client request included a token (such as a JWT, OAuth, or API key) that is expired, malformed, revoked, or unauthorized. This typically results in 4xx errors, especially 401 Unauthorized or 403 Forbidden responses.",
          },
          {
            name: "Generic-APIGW-Rest-ThrottleCountError-Alert",
            id: "867a4490-1f50-11f0-81de-7784ff1aaaea",
            description:
              "ThrottleCountError alert triggered form ELK when the number of requests rejected by a REST API because they exceeded the allowed rate limit or burst limit set by the API gateway typically resulting in 429 Too Many Requests status codes, as detected from logs ingested into ELK.",
          },
          {
            name: "Generic-APIGW-Rest-VpcLinkError-alert",
            id: "93beb560-2409-11f0-a9f8-3ba7ee780118",
            description:
              "A VPC Link Error alert is triggered when REST API traffic routed through API Gateway fails to connect to a private backend over the VPC Link due to network configuration issues, DNS resolution failures, or service unavailability, as detected in logs ingested into ELK.",
          },
        ],
      },
      {
        name: "websocketAlerts",
        prefix: "/app/observability/alerts/rules/",
        title: "Websocket Alerts",
        description:
          "These are the generic alert created for the Websocket API in EEM APIGateway Console based on metricbeat and filebeat. it capture the backend network,vpc link,invalid token,throttle request count and execution error in logs and notify EEM APIGW team by MS Team notification",
        items: [
          {
            name: "Generic-APIGW-Websocket-BackendNetworkError-alert",
            id: "f30628c0-240c-11f0-9d30-fd44abfeb00b",
            description:
              "A Backend Network Error alert of WebSocket API trigered form ELK in case of when the WebSocket connection attempts to communicate with the backend integration (like a Lambda function, HTTP endpoint, or VPC-connected service), but fails due to network issues.To understand this error logs may contains status: (502 or 504 or 500) api_type: websocket AND message: *endpoint request timed out*",
          },
          {
            name: "Generic-APIGW-Websocket-ExecutionError-alert",
            id: "41ac1710-240c-11f0-b6ad-0f24c92cb25d",
            description:
              "An ExecutionError alert is triggered when WebSocket API logs show that the backend service failed during the processing or execution of a request or message, usually due to application-level errors, exceptions, or timeouts, as captured in ELK.In ELK logs we can identify this error which shows the status: 500, 502, or 503 or Messages like:Execution failed, Internal server error,Unhandled exception",
          },
          {
            name: "Generic-APIGW-Websocket-InvalidToken-alert",
            id: "daf93580-240f-11f0-a9f8-3ba7ee780118",
            description:
              "Websocket InvalidToken alert is triggered when WebSocket API logs show that authentication or authorization failed during the $connect, $message, or $disconnect routes due to an invalid or expired token.To identify these with Status code: 401 Unauthorized, 403 Forbidden or Message can be either Invalid token,Token expired,Authorization failed",
          },
          {
            name: "Generic-APIGW-Websocket-ThrottledRequest-Alert",
            id: "4ed7ee10-324d-11f0-9d30-fd44abfeb00b",
            description:
              "A ThrottledRequest alert is triggered when Websocket API logs show that one or more client requests were rejected or delayed due to rate-limiting policies, typically returning a 429 Too Many Requests HTTP status code, or backend-specific throttle indicators, as detected by ELK.",
          },
          {
            name: "Generic-APIGW-Websocket-VPCLinkError-alert",
            id: "b75aee90-240d-11f0-b6ad-0f24c92cb25d",
            description:
              "A VPC Link Error alert is triggered when Websocket API traffic routed through API Gateway fails to connect to a private backend over the VPC Link due to network configuration issues, DNS resolution failures, or service unavailability, as detected in logs ingested into ELK.",
          },
        ],
      },
    ],
  },
  sit: {
    space: "eem_sit_space",
    items: [
      {
        name: "dashboards",
        prefix: "/app/dashboards#/view/",
        title: "Dashboards",
        description:
          "These are the APIGW monitoring dashboards in ELK. Configured these dashboards based on metricbeat,filebeat and latency. ",
        items: [
          {
            name: "EEM AWS API Gateway Dashboard - Filebeat",
            id: "4f47f403-a964-51cb-9dbb-7385854f67d7",
            description:
              "The EEM API Gateway Dashboard built on the ELK Stack using Filebeat provides real-time monitoring and insights into both REST and WebSocket API traffic of EEM.Filebeat is responsible for collecting logs from AWS API Gateway (via CloudWatch or S3), parsing them (directly or via Logstash), and forwarding them to Elasticsearch, where they are indexed and visualized in Kibana. It capture the Rest API Errors 4XX,Rest API Errors 5XX,Websocket API 4XX errors,Websocket API 5XX errors,Websocket API - Latency between CloudFront viewer request and response,RestApi - Latency between APigateway and curity authorizer,APIGateway Throttling Error - RestAPIs and APIGateway Throttling Error - WebsocketAPI",
          },
          {
            name: "EEM AWS API Gateway Dashboard - Metricbeats",
            id: "95f8921a-4c8f-5e84-8244-658b1dd9eef2",
            description:
              "This dashboard provides a comprehensive visualization of API usage patterns for both WebSocket and REST APIs managed under the EEM, using data collected via Metricbeat and displayed in Kibana on the ELK stack.This dashboard visualize the Top 10 REST API Routes(commonly invoked REST API endpoints and their relative usage) ,Top 10 WebSocket API Routes(Highlights the most frequently accessed WebSocket API routes, showing proportional usage),Bottom 10 WebSocket Routes(east-used WebSocket routes),Bottom 10 REST API Routes(least-called REST API routes),Rest/Websocket API calls per day, Rest/Websocket API trends per hour,Websocket API - Integration Latency(APIGW +Backend) by routes, Rest API- Integration Latency (API GW + Backend ) by routes, Websocket API - Round trip latency(Curity+APIGW+Backend) by routes, Rest API - Round trip latency(Curity +APIGW+Backend) by routes,Rest API 4XX and 5XX metrics,Websocket API error metrics,API Calls - All Websocket Routes calls and API Calls - All Rest methods calls",
          },
          {
            name: "EEM AWS API Gateway Dashboard - Latency",
            id: "b8475410-5770-5cd5-b880-fbd38be05ebf",
            description:
              "The EEM API Gateway Latency Dashboard is a Kibana visualization built on top of Filebeat-ingested logs that monitors API integration latency for both REST and WebSocket APIs in real time. It visualize the Rest API- Integration Latency (API GW + Backend ) by routes, Websocket API -Integration Latency(APIGW +Backend) by routes, Rest API - Round trip latency(Curity +APIGW+Backend) by routes and Websocket API - Round trip latency(Curity +APIGW+Backend) by routes",
          },
        ],
      },
      {
        name: "cloudfrontAlerts",
        prefix: "/app/observability/alerts/rules/",
        title: "Cloudfront Alerts",
        description:
          "This is the generic alert created for the cloudfront distribution based on metricbeat. it capture the 5xx error in the logs and notify EEM APIGW team by MS Team notification",
        items: [
          {
            name: "Generic-APIGW-CF- 5xxErrorRate -alert",
            id: "3de20730-5034-11f0-aa91-6f3acf4aaea6",
            description:
              "A CloudFront 5XXErrorRate alert monitors the rate of 5xx server errors (such as 500, 502, 503, 504) that occur between CloudFront and API.A CloudFront 5XXErrorRate alert is triggered when the percentage of server-side errors (HTTP 5xx status codes) returned by CloudFront to clients exceeds a defined threshold over a specified period.",
          },
        ],
      },
      {
        name: "restAlerts",
        prefix: "/app/observability/alerts/rules/",
        title: "REST Alerts",
        description:
          "These are the generic alert created for the REST API in EEM APIGateway Console based on metricbeat and filebeat. it capture the 4xx,5xx,latency,backend network,vpc link,invalid token,throttle request count and execution error in logs and notify EEM APIGW team by MS Team notification",
        items: [
          {
            name: "Generic-APIGW-Rest-BackendNetworkError-Alert",
            id: "d7f11d70-5034-11f0-b6ad-0f24c92cb25d",
            description:
              "A Backend Network Error alert in ELK for REST APIs is triggered when log data indicates that the API request failed to connect, timed out, or received no response from the backend service due to network connectivity problems, DNS resolution failures, or backend unavailability.",
          },
          {
            name: "Generic-APIGW-Rest-ExecutionError-alert",
            id: "6155ff40-5035-11f0-aa91-6f3acf4aaea6",
            description:
              "An ExecutionError alert is triggered from ELK when REST API logs show that a request was routed to the backend, but the execution of that request failed due to internal application errors, timeouts, or exceptions, typically resulting in 5xx HTTP status codes (e.g., 500, 502, 503).",
          },
          {
            name: "Generic-APIGW-Rest-InvalidToken-alert",
            id: "b5038180-5035-11f0-b6ad-0f24c92cb25d",
            description:
              "An InvalidToken alert in the context of a REST API monitored through ELK indicates that a client request included a token (such as a JWT, OAuth, or API key) that is expired, malformed, revoked, or unauthorized. This typically results in 4xx errors, especially 401 Unauthorized or 403 Forbidden responses.",
          },
          {
            name: "Generic-APIGW-Rest-ThrottleCountError-Alert",
            id: "4bde6ed0-5036-11f0-b6ad-0f24c92cb25d",
            description:
              "ThrottleCountError alert triggered form ELK when the number of requests rejected by a REST API because they exceeded the allowed rate limit or burst limit set by the API gateway typically resulting in 429 Too Many Requests status codes, as detected from logs ingested into ELK.",
          },
          {
            name: "Generic-APIGW-Rest-VpcLinkError-alert",
            id: "98781cf0-5036-11f0-b6ad-0f24c92cb25d",
            description:
              "A VPC Link Error alert is triggered when REST API traffic routed through API Gateway fails to connect to a private backend over the VPC Link due to network configuration issues, DNS resolution failures, or service unavailability, as detected in logs ingested into ELK.",
          },
        ],
      },
      {
        name: "websocketAlerts",
        prefix: "/app/observability/alerts/rules/",
        title: "Websocket Alerts",
        description:
          "These are the generic alert created for the Websocket API in EEM APIGateway Console based on metricbeat and filebeat. it capture the backend network,vpc link,invalid token,throttle request count and execution error in logs and notify EEM APIGW team by MS Team notification",
        items: [
          {
            name: "Generic-APIGW-Websocket-BackendNetworkError-alert",
            id: "d1173320-5036-11f0-aa91-6f3acf4aaea6",
            description:
              "A Backend Network Error alert of WebSocket API trigered form ELK in case of when the WebSocket connection attempts to communicate with the backend integration (like a Lambda function, HTTP endpoint, or VPC-connected service), but fails due to network issues.To understand this error logs may contains status: (502 or 504 or 500) api_type: websocket AND message: *endpoint request timed out*",
          },
          {
            name: "Generic-APIGW-Websocket-ExecutionError-alert",
            id: "13f063b0-5037-11f0-aa91-6f3acf4aaea6",
            description:
              "An ExecutionError alert is triggered when WebSocket API logs show that the backend service failed during the processing or execution of a request or message, usually due to application-level errors, exceptions, or timeouts, as captured in ELK.In ELK logs we can identify this error which shows the status: 500, 502, or 503 or Messages like:Execution failed, Internal server error,Unhandled exception",
          },
          {
            name: "Generic-APIGW-Websocket-InvalidToken-alert",
            id: "bf036720-5037-11f0-b6ad-0f24c92cb25d",
            description:
              "Websocket InvalidToken alert is triggered when WebSocket API logs show that authentication or authorization failed during the $connect, $message, or $disconnect routes due to an invalid or expired token.To identify these with Status code: 401 Unauthorized, 403 Forbidden or Message can be either Invalid token,Token expired,Authorization failed",
          },
          {
            name: "Generic-APIGW-Websocket-ThrottledRequest-Alert",
            id: "1e442b20-5038-11f0-b6ad-0f24c92cb25d",
            description:
              "A ThrottledRequest alert is triggered when Websocket API logs show that one or more client requests were rejected or delayed due to rate-limiting policies, typically returning a 429 Too Many Requests HTTP status code, or backend-specific throttle indicators, as detected by ELK.",
          },
          {
            name: "Generic-APIGW-Websocket-VPCLinkError-alert",
            id: "65c18f60-5038-11f0-aa91-6f3acf4aaea6",
            description:
              "A VPC Link Error alert is triggered when Websocket API traffic routed through API Gateway fails to connect to a private backend over the VPC Link due to network configuration issues, DNS resolution failures, or service unavailability, as detected in logs ingested into ELK.",
          },
        ],
      },
    ],
  },
  stage: {
    space: "eem_stag_space",
    items: [
      {
        name: "dashboards",
        prefix: "/app/dashboards#/view/",
        title: "Dashboards",
        description:
          "These are the APIGW monitoring dashboards in ELK. Configured these dashboards based on metricbeat,filebeat and latency. ",
        items: [
          {
            name: "EEM AWS API Gateway Dashboard - Filebeat",
            id: "34dbc6b5-8860-594e-9e20-200d4c2ca4b9",
            description:
              "The EEM API Gateway Dashboard built on the ELK Stack using Filebeat provides real-time monitoring and insights into both REST and WebSocket API traffic of EEM.Filebeat is responsible for collecting logs from AWS API Gateway (via CloudWatch or S3), parsing them (directly or via Logstash), and forwarding them to Elasticsearch, where they are indexed and visualized in Kibana. It capture the Rest API Errors 4XX,Rest API Errors 5XX,Websocket API 4XX errors,Websocket API 5XX errors,Websocket API - Latency between CloudFront viewer request and response,RestApi - Latency between APigateway and curity authorizer,APIGateway Throttling Error - RestAPIs and APIGateway Throttling Error - WebsocketAPI",
          },
          {
            name: "EEM AWS API Gateway Dashboard - Metricbeats",
            id: "1b7831bc-8327-5f65-9bae-13f17d3f46e6",
            description:
              "This dashboard provides a comprehensive visualization of API usage patterns for both WebSocket and REST APIs managed under the EEM, using data collected via Metricbeat and displayed in Kibana on the ELK stack.This dashboard visualize the Top 10 REST API Routes(commonly invoked REST API endpoints and their relative usage) ,Top 10 WebSocket API Routes(Highlights the most frequently accessed WebSocket API routes, showing proportional usage),Bottom 10 WebSocket Routes(east-used WebSocket routes),Bottom 10 REST API Routes(least-called REST API routes),Rest/Websocket API calls per day, Rest/Websocket API trends per hour,Websocket API - Integration Latency(APIGW +Backend) by routes, Rest API- Integration Latency (API GW + Backend ) by routes, Websocket API - Round trip latency(Curity+APIGW+Backend) by routes, Rest API - Round trip latency(Curity +APIGW+Backend) by routes,Rest API 4XX and 5XX metrics,Websocket API error metrics,API Calls - All Websocket Routes calls and API Calls - All Rest methods calls",
          },
          {
            name: "EEM AWS API Gateway Dashboard - Latency",
            id: "2bd34335-c9a9-5181-88cd-a12429042a99",
            description:
              "The EEM API Gateway Latency Dashboard is a Kibana visualization built on top of Filebeat-ingested logs that monitors API integration latency for both REST and WebSocket APIs in real time. It visualize the Rest API- Integration Latency (API GW + Backend ) by routes, Websocket API -Integration Latency(APIGW +Backend) by routes, Rest API - Round trip latency(Curity +APIGW+Backend) by routes and Websocket API - Round trip latency(Curity +APIGW+Backend) by routes",
          },
        ],
      },
      {
        name: "cloudfrontAlerts",
        prefix: "/app/observability/alerts/rules/",
        title: "Cloudfront Alerts",
        description:
          "This is the generic alert created for the cloudfront distribution based on metricbeat. it capture the 5xx error in the logs and notify EEM APIGW team by MS Team notification",
        items: [
          {
            name: "Generic-APIGW-CF- 5xxErrorRate -alert",
            id: "3aeb3200-500b-11f0-a9f8-3ba7ee780118",
            description:
              "A CloudFront 5XXErrorRate alert monitors the rate of 5xx server errors (such as 500, 502, 503, 504) that occur between CloudFront and API.A CloudFront 5XXErrorRate alert is triggered when the percentage of server-side errors (HTTP 5xx status codes) returned by CloudFront to clients exceeds a defined threshold over a specified period.",
          },
        ],
      },
      {
        name: "restAlerts",
        prefix: "/app/observability/alerts/rules/",
        title: "REST Alerts",
        description:
          "These are the generic alert created for the REST API in EEM APIGateway Console based on metricbeat and filebeat. it capture the 4xx,5xx,latency,backend network,vpc link,invalid token,throttle request count and execution error in logs and notify EEM APIGW team by MS Team notification",
        items: [
          {
            name: "Generic-APIGW-Rest-BackendNetworkError-Alert",
            id: "87c51610-500e-11f0-9c33-7f85a1328d7a",
            description:
              "A Backend Network Error alert in ELK for REST APIs is triggered when log data indicates that the API request failed to connect, timed out, or received no response from the backend service due to network connectivity problems, DNS resolution failures, or backend unavailability.",
          },
          {
            name: "Generic-APIGW-Rest-ExecutionError-alert",
            id: "d7cc4ca0-500e-11f0-9c33-7f85a1328d7a",
            description:
              "An ExecutionError alert is triggered from ELK when REST API logs show that a request was routed to the backend, but the execution of that request failed due to internal application errors, timeouts, or exceptions, typically resulting in 5xx HTTP status codes (e.g., 500, 502, 503).",
          },
          {
            name: "Generic-APIGW-Rest-InvalidToken-alert",
            id: "20817e80-5018-11f0-9c33-7f85a1328d7a",
            description:
              "An InvalidToken alert in the context of a REST API monitored through ELK indicates that a client request included a token (such as a JWT, OAuth, or API key) that is expired, malformed, revoked, or unauthorized. This typically results in 4xx errors, especially 401 Unauthorized or 403 Forbidden responses.",
          },
          {
            name: "Generic-APIGW-Rest-ThrottleCountError-Alert",
            id: "548b86c0-5019-11f0-aa91-6f3acf4aaea6",
            description:
              "ThrottleCountError alert triggered form ELK when the number of requests rejected by a REST API because they exceeded the allowed rate limit or burst limit set by the API gateway typically resulting in 429 Too Many Requests status codes, as detected from logs ingested into ELK.",
          },
          {
            name: "Generic-APIGW-Rest-VpcLinkError-alert",
            id: "bbc94660-5019-11f0-aa91-6f3acf4aaea6",
            description:
              "A VPC Link Error alert is triggered when REST API traffic routed through API Gateway fails to connect to a private backend over the VPC Link due to network configuration issues, DNS resolution failures, or service unavailability, as detected in logs ingested into ELK.",
          },
        ],
      },
      {
        name: "websocketAlerts",
        prefix: "/app/observability/alerts/rules/",
        title: "Websocket Alerts",
        description:
          "These are the generic alert created for the Websocket API in EEM APIGateway Console based on metricbeat and filebeat. it capture the backend network,vpc link,invalid token,throttle request count and execution error in logs and notify EEM APIGW team by MS Team notification",
        items: [
          {
            name: "Generic-APIGW-Websocket-BackendNetworkError-alert",
            id: "18ab80f0-501a-11f0-a9f8-3ba7ee780118",
            description:
              "A Backend Network Error alert of WebSocket API trigered form ELK in case of when the WebSocket connection attempts to communicate with the backend integration (like a Lambda function, HTTP endpoint, or VPC-connected service), but fails due to network issues.To understand this error logs may contains status: (502 or 504 or 500) api_type: websocket AND message: *endpoint request timed out*",
          },
          {
            name: "Generic-APIGW-Websocket-InvalidToken-alert",
            id: "d8d53ab0-501a-11f0-aa91-6f3acf4aaea6",
            description:
              "Websocket InvalidToken alert is triggered when WebSocket API logs show that authentication or authorization failed during the $connect, $message, or $disconnect routes due to an invalid or expired token.To identify these with Status code: 401 Unauthorized, 403 Forbidden or Message can be either Invalid token,Token expired,Authorization failed",
          },
          {
            name: "Generic-APIGW-Websocket-ThrottledRequest-Alert",
            id: "8274ff10-501b-11f0-9c33-7f85a1328d7a",
            description:
              "A ThrottledRequest alert is triggered when Websocket API logs show that one or more client requests were rejected or delayed due to rate-limiting policies, typically returning a 429 Too Many Requests HTTP status code, or backend-specific throttle indicators, as detected by ELK.",
          },
          {
            name: "Generic-APIGW-Websocket-VPCLinkError-alert",
            id: "cb1ed560-501b-11f0-b6ad-0f24c92cb25d",
            description:
              "A VPC Link Error alert is triggered when Websocket API traffic routed through API Gateway fails to connect to a private backend over the VPC Link due to network configuration issues, DNS resolution failures, or service unavailability, as detected in logs ingested into ELK.",
          },
        ],
      },
    ],
  },
  prod: {
    space: "eem_prod_space",
    items: [
      {
        name: "dashboards",
        prefix: "/app/dashboards#/view/",
        title: "Dashboards",
        description:
          "These are the APIGW monitoring dashboards in ELK. Configured these dashboards based on metricbeat,filebeat and latency. ",
        items: [
          {
            name: "EEM AWS API Gateway Dashboard - Filebeat",
            id: "e3e747ea-9b3f-51d8-9864-ad1170f48725",
            description:
              "The EEM API Gateway Dashboard built on the ELK Stack using Filebeat provides real-time monitoring and insights into both REST and WebSocket API traffic of EEM.Filebeat is responsible for collecting logs from AWS API Gateway (via CloudWatch or S3), parsing them (directly or via Logstash), and forwarding them to Elasticsearch, where they are indexed and visualized in Kibana. It capture the Rest API Errors 4XX,Rest API Errors 5XX,Websocket API 4XX errors,Websocket API 5XX errors,Websocket API - Latency between CloudFront viewer request and response,RestApi - Latency between APigateway and curity authorizer,APIGateway Throttling Error - RestAPIs and APIGateway Throttling Error - WebsocketAPI",
          },
          {
            name: "EEM AWS API Gateway Dashboard - Metricbeats",
            id: "ec5a9a8d-953b-5701-9a67-d1a26a1ef0af",
            description:
              "This dashboard provides a comprehensive visualization of API usage patterns for both WebSocket and REST APIs managed under the EEM, using data collected via Metricbeat and displayed in Kibana on the ELK stack.This dashboard visualize the Top 10 REST API Routes(commonly invoked REST API endpoints and their relative usage) ,Top 10 WebSocket API Routes(Highlights the most frequently accessed WebSocket API routes, showing proportional usage),Bottom 10 WebSocket Routes(east-used WebSocket routes),Bottom 10 REST API Routes(least-called REST API routes),Rest/Websocket API calls per day, Rest/Websocket API trends per hour,Websocket API - Integration Latency(APIGW +Backend) by routes, Rest API- Integration Latency (API GW + Backend ) by routes, Websocket API - Round trip latency(Curity+APIGW+Backend) by routes, Rest API - Round trip latency(Curity +APIGW+Backend) by routes,Rest API 4XX and 5XX metrics,Websocket API error metrics,API Calls - All Websocket Routes calls and API Calls - All Rest methods calls",
          },
          {
            name: "EEM AWS API Gateway Dashboard - Latency",
            id: "7c57b98b-9c3b-5610-b212-bf2c56797b83",
            description:
              "The EEM API Gateway Latency Dashboard is a Kibana visualization built on top of Filebeat-ingested logs that monitors API integration latency for both REST and WebSocket APIs in real time. It visualize the Rest API- Integration Latency (API GW + Backend ) by routes, Websocket API -Integration Latency(APIGW +Backend) by routes, Rest API - Round trip latency(Curity +APIGW+Backend) by routes and Websocket API - Round trip latency(Curity +APIGW+Backend) by routes",
          },
        ],
      },
      {
        name: "cloudfrontAlerts",
        prefix: "/app/observability/alerts/rules/",
        title: "Cloudfront Alerts",
        description:
          "This is the generic alert created for the cloudfront distribution based on metricbeat. it capture the 5xx error in the logs and notify EEM APIGW team by MS Team notification and P3 incidnet on Service now",
        items: [
          {
            name: "Generic-APIGW-CF- 5xxErrorRate -alert",
            id: "eabad4c0-325f-11f0-b6ad-0f24c92cb25d",
            description:
              "A CloudFront 5XXErrorRate alert monitors the rate of 5xx server errors (such as 500, 502, 503, 504) that occur between CloudFront and API.A CloudFront 5XXErrorRate alert is triggered when the percentage of server-side errors (HTTP 5xx status codes) returned by CloudFront to clients exceeds a defined threshold over a specified period.",
          },
        ],
      },
      {
        name: "restAlerts",
        prefix: "/app/observability/alerts/rules/",
        title: "REST Alerts",
        description:
          "These are the generic alert created for the REST API in EEM APIGateway Console based on metricbeat and filebeat. it capture the 4xx,5xx,latency,backend network,vpc link,invalid token,throttle request count and execution error in logs and notify EEM APIGW team by MS Team notification and P3 incident on Service now",
        items: [
          {
            name: "Generic-APIGW-Rest-BackendNetworkError-Alert",
            id: "f89048e0-3260-11f0-b6ad-0f24c92cb25d",
            description:
              "A Backend Network Error alert in ELK for REST APIs is triggered when log data indicates that the API request failed to connect, timed out, or received no response from the backend service due to network connectivity problems, DNS resolution failures, or backend unavailability.",
          },
          {
            name: "Generic-APIGW-Rest-ExecutionError-alert",
            id: "be52f690-3261-11f0-a9f8-3ba7ee780118",
            description:
              "An ExecutionError alert is triggered from ELK when REST API logs show that a request was routed to the backend, but the execution of that request failed due to internal application errors, timeouts, or exceptions, typically resulting in 5xx HTTP status codes (e.g., 500, 502, 503).",
          },
          {
            name: "Generic-APIGW-Rest-InvalidToken-alert",
            id: "49da6a40-3262-11f0-b6ad-0f24c92cb25d",
            description:
              "An InvalidToken alert in the context of a REST API monitored through ELK indicates that a client request included a token (such as a JWT, OAuth, or API key) that is expired, malformed, revoked, or unauthorized. This typically results in 4xx errors, especially 401 Unauthorized or 403 Forbidden responses.",
          },
          {
            name: "Generic-APIGW-Rest-ThrottleCountError-Alert",
            id: "f8a48240-3262-11f0-a9f8-3ba7ee780118",
            description:
              "ThrottleCountError alert triggered form ELK when the number of requests rejected by a REST API because they exceeded the allowed rate limit or burst limit set by the API gateway typically resulting in 429 Too Many Requests status codes, as detected from logs ingested into ELK.",
          },
          {
            name: "Generic-APIGW-Rest-VpcLinkError-alert",
            id: "80b12710-3263-11f0-9d30-fd44abfeb00b",
            description:
              "A VPC Link Error alert is triggered when REST API traffic routed through API Gateway fails to connect to a private backend over the VPC Link due to network configuration issues, DNS resolution failures, or service unavailability, as detected in logs ingested into ELK.",
          },
        ],
      },
      {
        name: "websocketAlerts",
        prefix: "/app/observability/alerts/rules/",
        title: "Websocket Alerts",
        description:
          "These are the generic alert created for the Websocket API in EEM APIGateway Console based on metricbeat and filebeat. it capture the backend network,vpc link,invalid token,throttle request count and execution error in logs and notify EEM APIGW team by MS Team notification and P3 Incidnet on Service Now",
        items: [
          {
            name: "Generic-APIGW-Websocket-BackendNetworkError-alert",
            id: "089953f0-3264-11f0-a9f8-3ba7ee780118",
            description:
              "A Backend Network Error alert of WebSocket API trigered form ELK in case of when the WebSocket connection attempts to communicate with the backend integration (like a Lambda function, HTTP endpoint, or VPC-connected service), but fails due to network issues.To understand this error logs may contains status: (502 or 504 or 500) api_type: websocket AND message: *endpoint request timed out*",
          },
          {
            name: "Generic-APIGW-Websocket-ExecutionError-alert",
            id: "9e11cb10-3264-11f0-9d30-fd44abfeb00b",
            description:
              "An ExecutionError alert is triggered when WebSocket API logs show that the backend service failed during the processing or execution of a request or message, usually due to application-level errors, exceptions, or timeouts, as captured in ELK.In ELK logs we can identify this error which shows the status: 500, 502, or 503 or Messages like:Execution failed, Internal server error,Unhandled exception",
          },
          {
            name: "Generic-APIGW-Websocket-InvalidToken-alert",
            id: "57bc2880-3265-11f0-9c33-7f85a1328d7a",
            description:
              "Websocket InvalidToken alert is triggered when WebSocket API logs show that authentication or authorization failed during the $connect, $message, or $disconnect routes due to an invalid or expired token.To identify these with Status code: 401 Unauthorized, 403 Forbidden or Message can be either Invalid token,Token expired,Authorization failed",
          },
          {
            name: "Generic-APIGW-Websocket-ThrottledRequest-Alert",
            id: "65280560-3266-11f0-a9f8-3ba7ee780118",
            description:
              "A ThrottledRequest alert is triggered when Websocket API logs show that one or more client requests were rejected or delayed due to rate-limiting policies, typically returning a 429 Too Many Requests HTTP status code, or backend-specific throttle indicators, as detected by ELK.",
          },
          {
            name: "Generic-APIGW-Websocket-VPCLinkError-alert",
            id: "d0d04080-3265-11f0-9c33-7f85a1328d7a",
            description:
              "A VPC Link Error alert is triggered when Websocket API traffic routed through API Gateway fails to connect to a private backend over the VPC Link due to network configuration issues, DNS resolution failures, or service unavailability, as detected in logs ingested into ELK.",
          },
        ],
      },
    ],
  },
};

export function toUrl(space, prefix, id) {
  return ELK_MONITORING_CONFIG.host + space + prefix + id;
}
